import './reportsPage.scss';

import { format } from 'date-fns';
import * as React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { setLoading, setSuccess } from '../../../actions/loadingActions';
import { IHistory } from '../../../interfaces';
import { ChecklistModel } from '../../../model/ChecklistModel';
import { getDailyChecklistData } from '../../../services/dailyFormService';
import { getQuestions, prepareTable } from '../../../services/formService';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Loader } from '../../reusableComponents/Loader';
import { MonthPicker } from '../../reusableComponents/MonthPicker';
import { monthsAndYears, inspectionType } from '../../../constants/generals'; 
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export interface IDailyChecklistReportProps {
    id: string;
    plantId: string;
    formType: string;
    history: IHistory;
    date: string;
    checkListInstance: ChecklistModel;
}

export interface IDailyChecklistReportState {
    date: string;
    questions: {
        Question: string;
    }[];
}

export class DailyChecklistReportImpl extends React.Component<IDailyChecklistReportProps,
    IDailyChecklistReportState> {
    constructor(props: IDailyChecklistReportProps) {
        super(props);

        this.state = { date: (props.date), questions: [] };
    }

    promise = async () => {
        await getDailyChecklistData(this.props.id, this.props.date, this.props.formType);
        const questions = await getQuestions(this.props.formType);
        this.setState({ questions });
    }

    filterList = async (date) => {
        const { formType, history: { push } } = this.props;
        let [day, month, year] = date.split('-');
        monthsAndYears.map((data) => {
            if (data.label === month) {
                month = `${data.value}${date.substring(date.length - 4)}`;
            }
        });
        setLoading('DailyChecklistData');
        await getDailyChecklistData(this.props.id, month, this.props.formType);
        this.setState({
            date
        });
        /*tslint:disable-next-line*/
        push(`/summary-reports/${formType}/${this.props.plantId}/${month}/${this.props.id}`);
        setSuccess('DailyChecklistData');
    }

    renderAnswers = () => {
        if (!this.props.checkListInstance) {
            return <span />;
        }
        const { checkListInstance: { props: { answers } } } = this.props;
        const Tick = <i className="fa fa-check" aria-hidden="true"></i>;
        const Cross = <i className="fa fa-close"></i>; 
        return <div className="answers" >
            {answers.map((data, index) => {
                return <div
                    key={index + 99}
                    style={{ display: 'inline-block', width: `${100 / answers.length}%` }}
                    className="answer-row"
                >
                    {answers[index].data.map((answerData, index) => {
                       /*  if( (this.props.formType =='PlantPreventive' ) && answerData.answer['quesNum'] =='28') {  //For omit time
                            return  
                        } */
                        if(answerData.answer['quesNum']!=='None') {
                            
                            let answer = answerData.answer.answer;
                            return <h4
                                key={index}
                                className="answer-column"
                            >
                                {answer? <OverlayTrigger placement="top" overlay={ <Tooltip id={`Tooltip - ${answerData.answer['quesNum']} - ${answerData.answer.date}`}> <span>{ answerData.answer['quesNum'] === '61' ? format(answer, 'MM/DD/YYYY') : answer}</span> </Tooltip>}>
                                    {answerData.answer['quesNum'] === '61' ? <span style={{ opacity: 1, fontSize: '15px', cursor:'default', width:'100%',wordWrap: 'break-word' }} >{format(answer, 'MM/DD') }</span>: <span style={{ opacity: 1, fontSize: '15px', cursor:'default' }} >{ (answer==='Yes' || answer==='Ok'? Tick : (answer==='No' || answer.indexOf('Needs work-') > -1 ? Cross : ( answer.length > 3 ? answer.substring(0, 2) + ".." : answer) ) ) }</span> }
                                </OverlayTrigger>:''}
                               {/*  {this.props.formType !== 'PlantPreventive' ? answerData.answer.answer ?
                                    (answerData.answer.answer === 'Yes' ? Tick :
                                        (answerData.answer.answer === 'No' ? Cross : '')) :
                                    '' :
                                    (answerData.answer.answer ?
                                        (answerData.answer.answer === 'Ok' ?
                                            Tick : answerData.answer.answer.indexOf('Needs work-') > -1 ? Cross : '')
                                        : '')
                                } */}
                            </h4>;
                        }
                    })}
                </div>;
            })}
        </div>;
    }

    renderDates = () => {
        const questions = ChecklistModel.getDailyFormQuestions();
        if (!this.props.checkListInstance) {
            return <span />;
        }
        const { checkListInstance: { props: { answers } } } = this.props;
        return <div className="dates" >
            {answers.map((que, index) => {
                return <h4 key={index + 999} style={{ width: `${100 / answers.length}%` }}  >
                    {que.data[0].answer.date}
                </h4>;
            })}
        </div>;
    }

    renderQuestions = () => {
        const questions = this.state.questions;
        return <div className="questions" >
            {questions.map((que, index) => {
                return <h4 key={index + 88}  >{que.Question}</h4>;
            })}
        </div>;
    }

    renderContent = () => {
        if (!this.props.checkListInstance) {
            return <span />;
        }
        const { checkListInstance: { props: { answers } } } = this.props;
        let month;
        const defaultMonth = monthsAndYears.map((data) => {
            if (data.value === this.state.date.substring(0, 2)) {
                month = `${data.label} ${this.state.date.substring(this.state.date.length - 4)}`;
            }
        });
        const dummyMonth_OLD =
            this.props.date.substring(0, 2) + '-01-' + this.props.date.substring(this.state.date.length - 4);

        const dummyMonth = this.props.date.substring(0, 2) + '-01-' + this.state.date.substring(this.state.date.length - 4);  

        return <div>
            <div className="chart-title" id="chartTitle"  >
                <MonthPicker
                    defaultValue={dummyMonth}
                    years={[2013, 2015, 2016]}
                    onClick={this.filterList}
                    popover={false}
                />
            </div>
            <Async
                identifier="DailyChecklistData"
                promise={() => setSuccess('DailyChecklistData')}
                loader={<Loader type="async" />}
                content={
                    <div style={{ display: 'flex' }} >
                        <div className="dates-row" >{this.renderDates()}</div>
                        <PerfectScrollbar>
                            <div id="summaryContainer" style={{ height: '84vh' }} >
                                <div className="questions-column" >{this.renderQuestions()}</div>
                                <div className="answers-data" >{this.renderAnswers()}</div>
                            </div>
                        </PerfectScrollbar>
                    </div>
                }
                error={<ErrorPage />}
            />
        </div >;
    }

    handlePrint = () => {
        let month = '';
        monthsAndYears.map((data) => {
            if (data.value === this.props.date.substr(0, 2)) {
                month = `${data.label}`;
            }
        });
        const { checkListInstance } = this.props;
        prepareTable(checkListInstance,
            this.state.questions,
            `${inspectionType(this.props.formType)} Reports for Plant ${this.props.plantId} 
            (${month} ${this.props.date.substring(this.props.date.length - 4)})`, 13, 'Days');
    }

    render() {
        let month = '';
        monthsAndYears.map((data) => {
            if (data.value === this.props.date.substr(0, 2)) {
                month = `${data.label}`;
            }
        });
        return <BasePage
            className="daily-checklist"
            pageTitle=
            {`${inspectionType(this.props.formType )} Reports for ${month} - ${this.props.date.substring(this.props.date.length - 4)} for Plant ${this.props.plantId}`}
            sideButton={
                <div key="details" onClick={this.handlePrint} className="button" id="print-button" style={{
                    position: 'absolute',
                    right: '10px',
                    width: 'fit-content',
                    paddingRight: '10px'
                }} >
                    <i className="fa fa-print" aria-hidden="true"></i>
                    &nbsp;
                    <span> Print</span>
                </div>
            }
        >
            <Async
                identifier="DailyChecklistReport"
                promise={this.promise}
                loader={<Loader type="async" />}
                content={this.renderContent()}
                error={<ErrorPage />}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    const formType = ownProps.match.params.formType;
    const checkListInstance = ChecklistModel.get(id, state);
    return {
        checkListInstance,
        id: ownProps.match.params.id,
        plantId: ownProps.match.params.plantId,
        date: ownProps.match.params.date,
        formType
    };
}

export const DailyChecklistReport =
    withRouter(connect<{}, {}, IDailyChecklistReportProps>(mapStateToProps)(DailyChecklistReportImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Summary/ReportsPage/DailyChecklistReport.tsx